import { defineStore } from 'pinia'
import SensorExtractionState, { SensorExtractionStateType } from './state'
import { SensorExtractionActions, SensorExtractionActionsType } from './actions'
import { SensorExtractionGetters } from './getters'

export const useSensorExtractionStore = defineStore<
  'sensorExtraction',
  SensorExtractionStateType,
  typeof SensorExtractionGetters,
  SensorExtractionActionsType
>('sensorExtraction', {
  state: SensorExtractionState,
  actions: SensorExtractionActions,
  getters: SensorExtractionGetters,
})
